<script>
    import { onMount } from 'svelte';
    import PublicNavbar from '../../components/PublicNavbar.svelte';
    import { user, setUser, signIn, signOut } from "../../store/auth.js";
    import { loader } from "../../store/shared.js";

    export let currentRoute;
    export let params;

    var errorMessage = '';

    var email = '';
    var password = '';

    async function signUserIn(e) {
        errorMessage = ''
        signIn(email, password)
            .then(reuslt => {
            })
            .catch(error => {
                if (error && error['message']) {
                    errorMessage = error['message']
                } else {
                    errorMessage = 'Something went wrong'
                }
            });
    }

</script>

<PublicNavbar showLogin={false} showSupport={true} />

<div class="container-fluid" style="height: 100% !important;">
    <div class="row alignment">
        <div class="col-lg-4 col-md-4 col-sm-7 col-xs-12 signin-form">
            <form autocomplete="false" class="inner-form" role="form" data-toggle="validator" onsubmit="return false">
                <div class="form-group" style="padding-bottom: 20px; text-align: center;">
                    <span>Login Tamseel Admin</span>
                </div>
                <div class="form-group">
                    <input on:keyup.enter="{signUserIn}" bind:value={email} type="email" class="form-control" id="email"
                        aria-describedby="emailHelp" required data-error="Please enter a valid email."
                        placeholder="Email">
                </div>
                <div class="form-group">
                    <input on:keyup.enter="{signUserIn}" bind:value={password} type="password" minlength="6"
                        class="form-control" id="password" required placeholder="Password" aria-required="true">
                </div>
                <div class="form-group">
                    {#if !$loader} <button on:click="{signUserIn}" class="btn btn-outline-primary btn-block">
                        Login
                    </button>
                    {:else}
                    <button class="btn btn-outline-primary btn-block" disabled> <i class="fa fa-circle-o-notch fa-spin"></i> Loading </button>
                    {/if}
                </div>
                <div class="form-group text-center py-2">
                    <a disabled="{$loader}" class="btn-block" href="/forgot-password" role="button">Forgot Password?</a>
                </div>
                {#if errorMessage}
                    <div style="position: absolute; min-width: 232px; max-width: 232px; line-height: 20px;" class="py-4 alert alert-danger" role="alert">
                        <strong>Alert!</strong> {errorMessage}
                    </div>
                {/if}
            </form>
        </div>
    </div>
</div>

<style>
    .alignment{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
        height: 100%;
    }
    .signin-form {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }


    .inner-form {
        padding: 50px 20px 50px 20px;
        overflow-y: auto;
        max-height: 100%;
    }

    .signin-background {
        height: calc(100vh);
        background: url('signin-background.png');
        background-position: center center;
        background-repeat: no-repeat;
    }

    @media (max-width: 575.98px) {
        .signin-background {
            display: none;
        }
    }
</style>